import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { RoleDto } from '../../dtos/role.dto';

@Injectable()
export class RolesRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(): Observable<readonly RoleDto[]> {
    return this.http.get<readonly RoleDto[]>(`${this.apiUrl}${API_ENDPOINTS.roles.list}`);
  }

  public setPermissions(roleId: number, permissions: readonly string[]): Observable<RoleDto> {
    return this.http.put<RoleDto>(`${this.apiUrl}${API_ENDPOINTS.roles.permissions(roleId)}`, { Permissions: permissions });
  }
}
